import "react";
const e = "data:image/svg+xml,%3csvg%20width='29'%20height='44'%20viewBox='0%200%2029%2044'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.7126%2022.2483L22.5077%2033.1266L11.7126%2044V22.2483Z'%20fill='%2372F3D1'/%3e%3cpath%20d='M18.0011%2022.1643L7%2011.0809L17.9986%200L18.0011%2022.1643Z'%20fill='%2372F3D1'/%3e%3c/svg%3e";
export {
  e as default
};
//# sourceMappingURL=stenn-logo-compact.svg.mjs.map
